/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SysParamDto } from '../../models/sys-param-dto';

export interface SysParamGetAsDto$Params {
  Group?: string;
  Name?: string;
  Value?: string;
  Description?: string;
  ParamType?: string;
  ApplicationType?: string;
  DefaultValue?: string;
}

export function sysParamGetAsDto(http: HttpClient, rootUrl: string, params?: SysParamGetAsDto$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
  const rb = new RequestBuilder(rootUrl, sysParamGetAsDto.PATH, 'get');
  if (params) {
    rb.query('Group', params.Group, {});
    rb.query('Name', params.Name, {});
    rb.query('Value', params.Value, {});
    rb.query('Description', params.Description, {});
    rb.query('ParamType', params.ParamType, {});
    rb.query('ApplicationType', params.ApplicationType, {});
    rb.query('DefaultValue', params.DefaultValue, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SysParamDto>;
    })
  );
}

sysParamGetAsDto.PATH = '/v1/SysParam/GetAsDTO';
